/**
 * Infinite Scroll / Load More for Collection Pages
 */

class CollectionInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.productGrid = document.getElementById('product-grid');
    this.paginationContainer = this.querySelector('.pagination-wrapper');
    this.loadMoreBtn = this.querySelector('.load-more-btn');
    this.loadingIndicator = this.querySelector('.loading-indicator');
    this.nextPageUrl = this.dataset.nextPage;
    this.isLoading = false;
    this.mode = this.dataset.mode || 'button'; // 'button' or 'infinite'

    this.init();
  }

  init() {
    if (!this.nextPageUrl || !this.productGrid) return;

    // Hide default pagination
    const defaultPagination = document.querySelector('.pagination');
    if (defaultPagination) {
      defaultPagination.style.display = 'none';
    }

    if (this.mode === 'button' && this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', () => this.loadMore());
    } else if (this.mode === 'infinite') {
      this.setupInfiniteScroll();
    }
  }

  setupInfiniteScroll() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading && this.nextPageUrl) {
          this.loadMore();
        }
      });
    }, {
      rootMargin: '200px'
    });

    if (this.loadingIndicator) {
      observer.observe(this.loadingIndicator);
    }
  }

  async loadMore() {
    if (this.isLoading || !this.nextPageUrl) return;

    this.isLoading = true;
    this.showLoading();

    try {
      const response = await fetch(this.nextPageUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get new products
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');

      if (newProducts.length > 0) {
        // Add animation class to new products
        newProducts.forEach((product, index) => {
          product.style.opacity = '0';
          product.style.transform = 'translateY(20px)';
          this.productGrid.appendChild(product);

          // Animate in with stagger
          setTimeout(() => {
            product.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            product.style.opacity = '1';
            product.style.transform = 'translateY(0)';
          }, index * 50);
        });
      }

      // Check for next page
      const nextLink = doc.querySelector('.pagination__item--next');
      if (nextLink) {
        this.nextPageUrl = nextLink.href;
        this.dataset.nextPage = this.nextPageUrl;
      } else {
        this.nextPageUrl = null;
        this.hideLoadMore();
      }

      // Update product count if exists
      const newCount = doc.querySelector('.product-count__text');
      const currentCount = document.querySelector('.product-count__text');
      if (newCount && currentCount) {
        currentCount.textContent = newCount.textContent;
      }

    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.isLoading = false;
      this.hideLoading();
    }
  }

  showLoading() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.classList.add('loading');
      this.loadMoreBtn.disabled = true;
    }
    if (this.loadingIndicator) {
      this.loadingIndicator.classList.add('active');
    }
  }

  hideLoading() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.classList.remove('loading');
      this.loadMoreBtn.disabled = false;
    }
    if (this.loadingIndicator) {
      this.loadingIndicator.classList.remove('active');
    }
  }

  hideLoadMore() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.style.display = 'none';
    }
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'none';
    }

    // Show "All products loaded" message
    const allLoadedMsg = this.querySelector('.all-loaded-message');
    if (allLoadedMsg) {
      allLoadedMsg.style.display = 'block';
    }
  }
}

customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
